import { render, staticRenderFns } from "./tab-spoiler.vue?vue&type=template&id=73f1723e"
import script from "./tab-spoiler.vue?vue&type=script&lang=js"
export * from "./tab-spoiler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports